interface UserVariables {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

/**
 * Replaces shortcode variables in notification content with actual user data.
 * Supported variables: {{firstName}}, {{lastName}}, {{fullName}}, {{email}}, {{siteUrl}}
 */
export const replaceNotificationVariables = (
  html: string | null | undefined,
  user: UserVariables
): string => {
  if (!html) return "";

  const siteUrl = window.location.origin;
  const firstName = user.firstName || "Utente";
  const lastName = user.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim();
  const email = user.email || "";

  return html
    .replace(/\{\{firstName\}\}/g, firstName)
    .replace(/\{\{lastName\}\}/g, lastName)
    .replace(/\{\{fullName\}\}/g, fullName)
    .replace(/\{\{email\}\}/g, email)
    .replace(/\{\{siteUrl\}\}/g, siteUrl);
};

/**
 * List of available notification variables for the RichTextEditor
 */
export const notificationVariables = [
  "firstName",
  "lastName",
  "fullName",
  "email",
  "siteUrl",
];
